// src/elements/HeaderShop.js

import React, { useEffect, useState, useContext } from "react";
import "../styles/global.css";
import { useNavigate } from "react-router-dom";
import { MenuDrawer } from "../screens/_menuDrawer";
import SearchFilters from "./SearchFilters";
import { useSearch } from "../context/SearchContext";
import { getAuth } from "firebase/auth";
import countCartItems from "../functions/countCartItems";
import { useFirestore } from "../firebase/FirestoreContext";
import { EnvContext } from "../context/EnvContext";
import { useSwipeable } from "react-swipeable";
import Tooltip from "@mui/material/Tooltip";
import config from "../config";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import StateSelector from "./StateSelector";
import Cookies from "js-cookie";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EnvironmentStatus from "./EnvironmentStatus";

import { logAnalyticsEvent } from "../firebase/firebaseConfig";
import { borderRadius, display, fontSize } from "@mui/system";

// mui x font

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

const NavigationSimple = ({ categoryTitle, containerStyle, color = "black" }) => {
  // environment
  const environment = useContext(EnvContext);
  //
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState("");
  const [isSearchEnabled, setSearchEnabled] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  const navigate = useNavigate();
  const auth = getAuth();
  const user = auth.currentUser;
  const firestore = useFirestore(); // Get Firestore instance
  const searchContext = useSearch(); // Use search context

  // environment
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  useEffect(() => {
    window.feather.replace();
  }, [isMenuOpen]);

  useEffect(() => {
    setSearchEnabled(localSearchTerm.length > 3);
  }, [localSearchTerm]);

  useEffect(() => {
    let unsubscribe; // Variable to hold the unsubscribe function

    if (user?.uid) {
      // Subscribe to cart item count updates if user is logged in
      unsubscribe = countCartItems(firestore, user.uid, setCartCount, collectionPath);
    } else {
      setCartCount(0); // Set count to 0 if no user is logged in
    }

    // Cleanup listener when the component is unmounted
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [firestore, user]);

  return (
    <>
      <EnvironmentStatus />
      <header
        style={{
          ...styles.header,
          ...containerStyle,
        }}
      >
        <div onClick={() => navigate(-1)}>
          <ArrowBackIcon style={{ color: color }} />
        </div>
        <div style={{ ...styles.title }}>{categoryTitle}</div>
      </header>
    </>
  );
};

// Styles for HeaderShop component (unchanged)
const styles = {
  header: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "0px 10px",
    cursor: "pointer",
  },
  title: {
    flex: 1,
    textAlign: "left",
    textTransform: "capitalize",
    fontSize: 22,
    fontWeight: "600",
    letterSpacing: ".2px",
    color: "black",
    padding: "5px 5px 5px 10px",
  },
};

export default NavigationSimple;
